/**
 * Created by bszggg on 2019. 06. 14..
 */
import Props from "../props";

const Api = {
  // baseUrl: "http://api.bpapi.hu/api_utc/apibp_frontend/",// LOCAL
  // baseUrl: "https://api.brightparrots.com/api_utc/apibp_frontend/", // Ez az API-val bővített
  // baseUrl: "http://192.168.1.55:3000/", //
  baseUrl: (Props.BASE_URL) ? Props.BASE_URL : "", //
  baseUrlAutoGeneratePort: (Props.BASE_URL_AUTOGENERATE_PORT) ? Props.BASE_URL_AUTOGENERATE_PORT : "", // base url by generate to same ip/name to this port
  apiUrl: (Props.API_URL) ? Props.API_URL : "api/", // Ez az API-val bővített


  // baseUrl: "http://api.brightparrots.com/apibp_frontend/", // Ez az alap backend a szerveren
  // baseUrl: "http://localhost/bp_backend/public/apibp_frontend/",
  // baseUrl: "http://api.bpapi.hu/apibp_frontend/",
  // baseUrl: "http://localhost/!_sct/slim-cors-test/web/public/",
  // baseUrl: "http://localhost/!_sct/slim-cors-test/web/public/apibp_frontend/",
  // baseUrl: "http://localhost/!_aa/slim-cors-test/web/public/cors-proba",
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },

  // TODO -- Ide kell egy filebeolvasás a root-ból, és abban lenne az api url.

  getBodyWithToken: function (data) {
    this.setBaseUrl();
    if (typeof data === "undefined" || data === null) {
      data = {};
    }
    data.system = "ADMIN";
    // if (localStorage&&localStorage.getItem("accesstoken")) {
    //   data.Token = localStorage.getItem("accesstoken");
    // }
    return data;
  },

  setBaseUrl: function () {
    console.log("setBaseUrl");
    if (this.baseUrlAutoGeneratePort) {
      this.baseUrl = document.location.protocol + '//' + document.location.hostname + ':' + this.baseUrlAutoGeneratePort + '/'
    } else if (this.baseUrl) {
      // this.baseUrl=baseUrl+'/'
    }
  },

  getHeader: function (header) {
    if (header) {
      header = Object.assign(Object.assign({}, Api.headers), header);
    } else {
      header = Object.assign({}, Api.headers);
    }
    if (localStorage && localStorage.getItem("accesstoken")) {
      header['Authorization'] = 'Bearer ' + localStorage.getItem("accesstoken");
    }
    return header;
  },

  // COMPANIES -- Leszedhető később, ha minden API-n keresztül elérhető lesz


  // getSharedCompaniesWithMe: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getSharedCompaniesWithMe";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + 'company/'+/*Api.apiUrl +*/ url, { //'company/'
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getCompany: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getCompany";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + 'company/'/*Api.apiUrl*/ + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveCompany: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveCompany";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },


  api1_0_0sum: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "sum";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  authMe: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "auth/me";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  register: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "auth/register";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  login: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "auth/login";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  logout: function (data) {
    data.Token = localStorage.removeItem("accesstoken");
    return new Promise(function (resolve) {
      resolve();
    });
    // const bodyData = this.getBodyWithToken(data);
    // const syncUrl = "authadmin/login";
    // return new Promise(function (resolve, reject) {
    //   bodyData.random = Math.random();
    //   fetch(Api.baseUrl + syncUrl, {
    //     body: JSON.stringify(bodyData),
    //     method: 'POST',
    //     headers: Api.headers,
    //   }).then(res => {
    //     return res.json()
    //   })
    //     .then(res => {
    //       resolve(res);
    //
    //     })
    //     .catch(error => {
    //       reject(error);
    //       console.error('Error:', error)
    //     });
    // });
  },


// API version API version API version API version API version API version API version API version API version API version API version

  healthCheck: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "check";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  getUseradmins: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "getUseradmins";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  getUseradmin: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "getUseradmin";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  saveUseradmin: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "saveUseradmin";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  getUsers: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "getUsers";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  getUser: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "getUser";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  saveUser: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "saveUser";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  saveMyUser: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const url = "saveMyUser ";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.baseUrl + Api.apiUrl + url, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.getHeader(),
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  // getMyCompanies: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getMyCompanies";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getMyCompany: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getMyCompany";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveMyCompany: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveMyCompany";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSharedCompaniesWithMe: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getSharedCompaniesWithMe";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // getUser2company: function (data) {
  // //   const bodyData = this.getBodyWithToken(data);
  // //   const url = "getUser2company";
  // //   return new Promise(function (resolve, reject) {
  // //     bodyData.random = Math.random();
  // //     fetch(Api.baseUrl + Api.apiUrl + url, {
  // //       body: JSON.stringify(bodyData),
  // //       method: 'POST',
  // //       headers: Api.getHeader(),
  // //     }).then(res => {
  // //       return res.json()
  // //     })
  // //       .then(res => {
  // //         resolve(res);
  // //       })
  // //       .catch(error => {
  // //         reject(error);
  // //         console.error('Error:', error)
  // //       });
  // //   });
  // // },
  //
  // getUserByEmail: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getUserByEmail";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getUser2companies: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getUser2companies";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // removeUserFromCompany: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "removeUserFromCompany";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveUser2company: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveUser2company";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // getUser2roleUsers: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getUser2roleUsers";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getUser2roleRoles: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getUser2roleRoles";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveUser2role: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveUser2role";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getCompany2module: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getCompany2module";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveCompany2module: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveCompany2module";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getAllSettings: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getAllSettings";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSettings: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getSettings";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveAllSettings: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveAllSettings";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getDocumentSerialNumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getDocumentSerialNumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveDocumentSerialNumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveDocumentSerialNumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveSettingsMoney: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveSettingsMoney";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveSettingsLang: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveSettingsLang";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveSettingsNav: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveSettingsNav";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // navTest: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "navTest";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // navGetDataByTaxnumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "navGetDataByTaxnumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // navRefreshPeriodInbound: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "navRefreshPeriodInbound";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // navRefreshPeriodOutbound: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "navRefreshPeriodOutbound";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // navRefreshQueryInvoiceData: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "navRefreshQueryInvoiceData";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // navGetInvoiceDetailData: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "navGetInvoiceDetailData";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  //
  //
  // getVats: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getVats";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getVat: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getVat";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveVat: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveVat";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  //
  //
  // getOtherIncomeExpenses: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getOtherIncomeExpenses";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getOtherIncomeExpense: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getOtherIncomeExpense";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveOtherIncomeExpense: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveOtherIncomeExpense";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getIncomeExpenseStatement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getIncomeExpenseStatement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceOutbounds: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceOutbounds";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInbounds: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInbounds";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSbInvoiceInbounds: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getSbInvoiceInbounds";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getTransferList: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getTransferList";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInboundsExport: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInboundsExport";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInboundsAccountant: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInboundsAccountant";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInboundsUploader: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInboundsUploader";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInboundsLeader: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInboundsLeader";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInboundsFinance: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInboundsFinance";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getInvoiceInbound: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getInvoiceInbound";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveInvoiceInbound: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveInvoiceInbound";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveCheckInvoiceInbound: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveCheckInvoiceInbound";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // deleteInvoiceInbound: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "deleteInvoiceInbound";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getBusinessPartners: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getBusinessPartners";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getBusinessPartner: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getBusinessPartner";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getBusinessPartnerByTaxnumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getBusinessPartnerByTaxnumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveBusinessPartner: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveBusinessPartner";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveBusinessPartnerBankAccountByTaxnumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveBusinessPartnerBankAccountByTaxnumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // FILES
  //
  // uploadFiles: function (data) {
  //   // const bodyData = this.getBodyWithToken(data);
  //   const url = "uploadFiles";
  //   return new Promise(function (resolve, reject) {
  //     // bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: data, // JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader({
  //         // 'Accept': 'application/json',
  //         'Accept': '*/*',
  //         'Content-Type': 'multipart/form-data; boundary=something'
  //       }),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getImagesData: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getImagesData";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // imageDelete: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "imageDelete";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getTasks: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getTasks";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // delTask: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "delTask";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // remember: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "remember";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // pset: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "pset";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getContracts: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getContracts";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getProformas: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getProformas";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getContract: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getContract";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getProforma: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "getProforma";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveContract: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveContract";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveProforma: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveProforma";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveProformaTransfered: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveProformaTransfered";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveInvoiceInboundTransfered: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveInvoiceInboundTransfered";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveInvoiceInboundExtrafields: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveInvoiceInboundExtrafields";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveInvoiceOutboundExtrafields: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "saveInvoiceOutboundExtrafields";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // doTest: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const url = "doTest";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.baseUrl + Api.apiUrl + url, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.getHeader(),
  //     }).then(res => {
  //       return res.json()
  //     })
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },


  // ------------------------------------------------- OLD -------------------------------------------------
  /*

   logout: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "auth/logout";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => {
   return res.json()
   })
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // USER
   getUsers: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getUsers";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getUser: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getUser";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveUser: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveUser";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getPartnerUsers: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getPartnerUsers";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getPartnerUser: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getPartnerUser";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   savePartnerUser: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "savePartnerUser";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   getDiscountChooses: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getDiscountChooses";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getDiscountChoose: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getDiscountChoose";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveDiscountChoose: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveDiscountChoose";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getMyUser: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getMyUser";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveMyUser: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveMyUser";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // ELEMENT
   getElements: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getElements";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getElement: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getElement";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   generateElementBarCode: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "generateElementBarCode";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   assembleElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "assembleElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   disassembleElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "disassembleElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // Stores
   getStores: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getStores";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getStore: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getStore";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveStore: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveStore";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // BusinessPartners
   getBusinessPartners: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getBusinessPartners";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getBusinessPartner: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getBusinessPartner";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveBusinessPartner: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveBusinessPartner";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // Company data
   getCompanyData: function () {
   const data = {
   data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getCompanyData";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveCompanyData: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveCompanyData";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // getAddress
   getAddresses: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getAddresses";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getAddress: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getAddress";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveAddress: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveAddress";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // Contacts
   getContacts: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getContacts";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getContact: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getContact";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveContact: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveContact";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },



   // Offer
   getOfferLists: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOfferLists";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getOfferList: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOfferList";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveOfferList: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveOfferList";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getOfferListElements: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOfferListElements";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getOfferListElement: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOfferListElement";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveOfferListElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveOfferListElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },




   // Shop
   getShopLists: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getShopLists";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getShopList: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getShopList";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveShopList: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveShopList";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getShopListElements: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getShopListElements";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getShopListElement: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getShopListElement";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveShopListElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveShopListElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },





   // Order
   getOrderLists: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOrderLists";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getOrderList: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOrderList";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveOrderList: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveOrderList";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getOrderListElements: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOrderListElements";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getOrderListlement: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getOrderListlement";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveOrderListElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveOrderListElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },





   // Revenue
   getRevenueLists: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRevenueLists";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getRevenueList: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRevenueList";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveRevenueList: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveRevenueList";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getRevenueListElements: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRevenueListElements";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getRevenueListElement: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRevenueListElement";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveRevenueListElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveRevenueListElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   // Revenue
   getDeliveryNotes: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getDeliveryNotes";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getDeliveryNote: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getDeliveryNote";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveDeliveryNote: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveDeliveryNote";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getRevenues: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRevenues";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getRevenue: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRevenue";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveRevenue: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveRevenue";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // vat
   getVats: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getVats";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getVat: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getVat";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveVat: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveVat";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // ListElement
   getListElements: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getListElements";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getListElement: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getListElement";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveListElement: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveListElement";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   getStockAlertByElementId: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getStockAlertByElementId";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getStockAlerts: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getStockAlerts";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   saveStockAlerts: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveStockAlerts";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getRecipesByElementId: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getRecipesByElementId";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   saveRecipes: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveRecipes";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   getWorkLogs: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getWorkLogs";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },



   // Workstations
   getWorkstations: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getWorkstations";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getWorkstation: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getWorkstation";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveWorkstation: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveWorkstation";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getDocumentSerialNumber: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getDocumentSerialNumber";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveDocumentSerialNumber: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveDocumentSerialNumber";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // Settings
   getSettings: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSettings";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   // getSetting: function (id) {
   //   const Api = this;
   //   const data = {
   //     id: id, data: Math.random()
   //   };
   //   const bodyData = this.getBodyWithToken(data);
   //   const syncUrl = "getSetting";
   //   return new Promise(function (resolve, reject) {
   //     fetch(Api.baseUrl + syncUrl, {
   //       body: JSON.stringify(bodyData),
   //       method: 'POST',
   //       headers: Api.headers
   //     }).then(res => res.json())
   //       .then(res => {
   //         resolve(res);
   //
   //       })
   //       .catch(error => {
   //         reject(error);
   //         console.error('Error:', error)
   //       });
   //   });
   // },
   // saveSettings: function (data) {
   //   const Api = this;
   //   const bodyData = this.getBodyWithToken(data);
   //   const syncUrl = "saveSettings";
   //   return new Promise(function (resolve, reject) {
   //     bodyData.random = Math.random();
   //     fetch(Api.baseUrl + syncUrl, {
   //       body: JSON.stringify(bodyData),
   //       method: 'POST',
   //       headers: Api.headers,
   //     }).then(res => res.json())
   //       .then(res => {
   //         resolve(res);
   //
   //       })
   //       .catch(error => {
   //         reject(error);
   //         console.error('Error:', error)
   //       });
   //   });
   // },
   saveSettingsMoney: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveSettingsMoney";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveSettingsLang: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveSettingsLang";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   cDataC: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "cDataC";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // sid and barcode
   getDataBySid: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getDataBySid";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   getElementCategoriesMultiParams: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getElementCategoriesMultiParams";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getElementsByMultiParams: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getElementsByMultiParams";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // ELEMENT_CATEGORY
   getElementCategories: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getElementCategories";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getElementCategory: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getElementCategory";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveElementCategory: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveElementCategory";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },

   // Buyer
   getBuyers: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getBuyers";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getBuyer: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getBuyer";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveBuyer: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveBuyer";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   // Contents
   getContents: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getContents";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getContent: function (id) {
   const data = {
   id: id, data: Math.random()
   };
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getContent";
   return new Promise(function (resolve, reject) {
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveContent: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveContent";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   saveContentPrintBlokk: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "saveContentPrintBlokk";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   fn: function (data) {

   },

   // SelDashboard queries
   getSelDashboardData: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSelDashboardData";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getSelStatByStore: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSelStatByStore";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getSelStatisticData: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSelStatisticData";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getSellDataExport: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSellDataExport";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getSellDetailsDataExport: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSellDetailsDataExport";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },



   getReportSellDetails: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getReportSellDetails";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   getReportBuyers: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getReportBuyers";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   getReportSellerUsers: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getReportSellerUsers";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },


   getSells: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSells";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   getSell: function (data) {
   const bodyData = this.getBodyWithToken(data);
   const syncUrl = "getSell";
   return new Promise(function (resolve, reject) {
   bodyData.random = Math.random();
   fetch(Api.baseUrl + syncUrl, {
   body: JSON.stringify(bodyData),
   method: 'POST',
   headers: Api.headers,
   }).then(res => res.json())
   .then(res => {
   resolve(res);

   })
   .catch(error => {
   reject(error);
   console.error('Error:', error)
   });
   });
   },
   */

}

export default Api;

